import React, { useEffect } from 'react';
import clsx from "clsx";
import { makeStyles, useTheme } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LanguageIcon from "@mui/icons-material/Language";
import HelpIcon from "@mui/icons-material/Help";
import FeedbackIcon from "@mui/icons-material/Feedback";
import MailIcon from "@mui/icons-material/Mail";
import CachedIcon from '@mui/icons-material/Cached';
import BlockIcon from '@mui/icons-material/Block';
import Link from "@mui/material/Link";
import axios from "../utils/axiosConfig";
import GenerateListIcon from "@mui/icons-material/Assessment";
import GenerateTestIcon from "@mui/icons-material/Assignment";
import PersonSearchIcon from '@mui/icons-material/Info';
import PersonSearchIcon2 from '@mui/icons-material/PersonSearch';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { useSelector } from 'react-redux'
import { getOrgId } from '../reducer/dashboardSlice';
const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    root: {
      display: "flex"
    },
    appBar: {
      zIndex: (theme?.zIndex?.drawer || 1200) + 1,
      transition: theme?.transitions?.create?.(["width", "margin"], {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.leavingScreen
      }) || 'none'
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme?.transitions?.create?.(["width", "margin"], {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.enteringScreen
      }) || 'none'
    },
    menuButton: {
      marginRight: 36
    },
    hide: {
      display: "none"
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap"
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme?.transitions?.create?.("width", {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.enteringScreen
      }) || 'none'
    },
    drawerClose: {
      transition: theme?.transitions?.create?.("width", {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.leavingScreen
      }) || 'none',
      overflowX: "hidden",
      width: 56,
      [theme?.breakpoints?.down?.("sm") || '@media (max-width:600px)']: {
        width: 48,
        paddingTop: '56px',
      },
    },
    drawer2Open: {
      width: drawerWidth,
      transition: theme?.transitions?.create?.("width", {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.enteringScreen
      }) || 'none'
    },
    drawer2Close: {
      transition: theme?.transitions?.create?.("width", {
        easing: theme?.transitions?.easing?.sharp,
        duration: theme?.transitions?.duration?.leavingScreen
      }) || 'none',
      overflowX: "hidden",
      width: (theme?.spacing?.(7) || 56) + 1,
      [theme?.breakpoints?.up?.("sm") || '@media (min-width:600px)']: {
        width: (theme?.spacing?.(9) || 72) + 1
      }
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      padding: theme?.spacing?.(0, 1) || '0 8px',
      ...(theme?.mixins?.toolbar || { minHeight: 56 }),
      [theme?.breakpoints?.down?.('sm') || '@media (max-width:600px)']: {
        minHeight: '84px',
      },
    },
    toolbar1: {
      display: "flex",
      justifyContent: "space-between",
      padding: theme?.spacing?.(0, 1) || '0 8px',
      ...(theme?.mixins?.toolbar || { minHeight: 56 })
    },
    content: {
      flexGrow: 1,
      padding: theme?.spacing?.(3) || '24px'
    },
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding:'3px 5px 0px 5px',
    },
    active: {
      color: theme?.palette?.primary?.main || '#1976d2',
      fontWeight: theme?.typography?.fontWeightMedium || 500,
      "& icon": {
        color: theme?.palette?.primary?.main || '#1976d2'
      }
    },
    inactive: {
      "& icon": {
        color: ""
      }
    },
    signOutButton: {
      marginLeft: theme?.spacing?.(1) || '8px'
    },
    listItemSelected: {
      backgroundColor: 'rgba(111, 41, 129, 0.13) !important',
      borderRadius: '8px',
      margin: '2px 8px',
    },
    listItemSelectedCollapsed: {
      backgroundColor: 'transparent !important',
      padding: '6px 0px',
      justifyContent: 'center',
      '& .MuiListItemIcon-root': {
        backgroundColor: 'rgba(111, 41, 129, 0.13)',
        borderRadius: '8px',
        padding: '8px',
        minWidth: 0,
        justifyContent: 'center',
      },
    },
    listItem: {
      borderRadius: '8px',
      margin: '2px 8px',
      '&:hover': {
        backgroundColor: 'rgba(111, 41, 129, 0.08)',
      },
    },
    listItemCollapsed: {
      padding: '6px 0px',
      justifyContent: 'center',
      '& .MuiListItemIcon-root': {
        minWidth: 0,
        padding: '8px',
        borderRadius: '8px',
        justifyContent: 'center',
      },
      '&:hover .MuiListItemIcon-root': {
        backgroundColor: 'rgba(111, 41, 129, 0.08)',
      },
    },
  }));



const DrawerComponent = (props) => {
    const classes = useStyles();
    const _theme = useTheme();
    //const [open, setOpen] = React.useState(false);
    const {open, dimensions, handleDrawerOpen,  _leftPanelMenu, handleDrawerClose, testType,  _setTypeButton,  _dispatch,  _setSelectedType,handleIconCLick,typeButton} = props;
    
    // let token = Cookies.get('token');

    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [poper, setPoper] = React.useState("");
    // eslint-disable-next-line unused-imports/no-unused-vars
    const [cssNav, setCssNav] = React.useState(["", "", "", "", "", "", "", ""]);
    

    //const preventDefault = event => event.preventDefault();

    

    let _leftNav = [
        "My Test",
        "Feedback",
        "Survey",
        "Completed",
        "Expired",
        "Site Requirements",
        "Support",
        "User Help",
        "Ongoing Tests",
        "Pending Results",
        "Regenerate Results",
        "Search Candidates",
        "Proctoring Insights"
        ];

    const handlePopoverOpen = (event, text) => {
        setAnchorEl(event.currentTarget);
        setPoper(text);
      };
    
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const openPop = Boolean(anchorEl);

    const renderSwitch = param => {
        switch (param) {
          case "Tests":
            return <AssignmentIcon />;
          case "Feedback":
            return <FeedbackIcon />;
          case "Survey":
            return <AssessmentIcon />;
          case "Completed":
            return <AssignmentTurnedInIcon />;
          case "Expired":
            return <AssignmentLateIcon />;
          case "WorkFlow":
            return <AssignmentTurnedInIcon />;
          case "Site Requirements":
            return <LanguageIcon />;
          case "Support":
            return <MailIcon />;
          case "User Help":
            return <HelpIcon />;
          case "Practice":
            return <CachedIcon />;
          case "Disabled Groups":
            return <BlockIcon />;
          case "Ongoing Tests":
            return <GenerateListIcon/>;
          case "Pending Results":
            return <GenerateTestIcon/>;
          case "Regenerate Results":
            return <PersonSearchIcon/>;
          case "Search Candidates":
            return <PersonSearchIcon2/>;
          case "Proctoring Insights":
            return <FactCheckIcon/>;
          default:
            return "";
        }
      };

      const selectMenuOption = (data) =>{
        switch (data) {
          case "Tests":
            return "Tests";
          case "Completed":
            return "Tests";
          case "Expired":
            return "Tests";
          case "Feedback":
            return "Feedback";
          case "FeedbackCompleted":
            return "Feedback";  
          case "FeedbackExpired":
            return "Feedback";
          case "Disabled Feedback":
            return "Disabled Groups";
          case "Disabled Survey":
            return "Disabled Groups";
          default:
            return "";
          }
      }

      useEffect(()=>{
        if(dimensions.width <= 767){
          handleDrawerClose()
        }else{
          handleDrawerOpen()
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[dimensions])

      const renderList = (text, index) => {
        return (
          <div key={index}>
            {text === "Site Requirements" ? <Divider /> : ""}
            {/* eslint-disable-next-line no-mixed-operators, react/jsx-no-comment-textnodes */}
            <ListItem button
              className={
                (selectMenuOption(typeButton)
                  ? selectMenuOption(typeButton) === text
                  : (typeButton && typeButton.toString().includes(text)))
                  ? (open ? classes.listItemSelected : classes.listItemSelectedCollapsed)
                  : (open ? classes.listItem : classes.listItemCollapsed)
              }
              // eslint-disable-next-line unused-imports/no-unused-vars
              onClick={e => handleIconCLick(index, text)}>
              <ListItemIcon
                onMouseEnter={e => handlePopoverOpen(e, text)}
                onMouseLeave={handlePopoverClose}
                className={`${cssNav[index]} gutter-icon`}
              >
                {/* {renderSwitch(text)} */}
                {text === 'User Help' ? (
                  <Typography style={{paddingBottom:'0px'}}>
                    <Link
                      href="../../docs/ConductOnlineTest.html"
                      target="_blank"
                      //onClick={preventDefault}
                      rel="noopener"
                      color="inherit"

                    >
                      {renderSwitch(text)}
                    </Link>
                  </Typography>
                ) : (
                renderSwitch(text)
                )}
              </ListItemIcon>
              {open && (
                <h5 className={cssNav[index]}>
                  {text === 'WorkFlow' ? 'Work Flow' : text}
                </h5>
              )}
            </ListItem>
            <Popover key={`pop${index}`}
              id="mouse-over-popover"
              className={classes.popover}
              classes={{
                paper: classes.paper
              }}
              open={!open && openPop}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "center",
                horizontal: "right"
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "left"
              }}
              // PaperProps={{
              //   style: { height: '3%' ,textAlign:"center"},
              // }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <h6 style={{marginTop:"3px"}}>{poper}</h6>
            </Popover>
          </div>
        );
      };

      const orgId = useSelector(getOrgId)

      React.useEffect(() => {
       if (orgId !== undefined && orgId !== "") {
        try {
          axios.get('/dashboard/getProfile',{  
              headers: {
                'Access-Control-Allow-Origin': '*',
                orgId: orgId,
              }
            }).then(profData =>{
               let userData = profData.data.profileData;
              setFirstName(userData.firstname);
              setLastName(userData.lastname);
              // setContactNo(userData.contact_number);
              // setUserInfoId(userData.id);
              // setEmail(userData.email_address);
          // eslint-disable-next-line unused-imports/no-unused-vars
          }).catch(error => {
             
          })
      } catch (error) {
       
      }
    }
         // requestUserMedia();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[useSelector(getOrgId)])
  
    return (
        <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open
          })
        }}
      >
        
        <div className={classes.toolbar}>
          <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
            {!open ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
          {open ? <h5><b> {firstName +' '+lastName}</b></h5> : null}
        </div>
        <Divider />
        <List key="list">{testType.map((text, index) => renderList(text, index))}</List>
      </Drawer>
    );
}


//Drawer
export default DrawerComponent;
